<!-- =========================================================================================
    File Name: TablePagination.vue
    Description: Add pagination to table for long data
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <vs-table max-items="15" pagination :data="orderErrors">

    <template slot="thead">
      <vs-th sort-key="id">Order ID</vs-th>
      <vs-th sort-key="name">Customer Name</vs-th>
      <vs-th sort-key="products">Products Purchased</vs-th>
      <vs-th sort-key="status">Order Status</vs-th>
      <vs-th sort-key="price">Amount</vs-th>
      <vs-th sort-key="date">Date</vs-th>
    </template>

    <template slot-scope="{data}" >
      <vs-tr :data="tr" :state="2 == 2 ? 'danger':null" :key="indextr" v-for="(tr, indextr) in data">

        <vs-td>
          <p class="product-id font-medium truncate">{{ tr.id }}</p>
        </vs-td>

        <vs-td>
          <p class="product-name">{{ tr.customer}}</p>
        </vs-td>

        <vs-td>
          <p class="product-price">{{ tr.products }}</p>
        </vs-td>

        <vs-td>
          <vs-chip :color="getOrderStatusColor(tr.status)" class="product-order-status">{{ tr.status}}</vs-chip>
        </vs-td>

        <vs-td>
          <p class="product-price">${{ tr.price }}</p>
        </vs-td>

        <vs-td>
          <p class="product-date">{{ getFormatedDate(tr.date) }}</p>
        </vs-td>

          <template class="expand-user" slot="expand">
            <div class="con-expand-users w-full">
              <div class="con-btns-user flex items-center justify-between">
                <div class="con-userx flex items-center justify-start">                  
                  <span>New feature coming here....</span>
                </div>
                <!-- <div class="flex">
                  <vs-button type="border" size="small" icon-pack="feather" icon="icon-send" color="success" class="mr-2"></vs-button>
                  <vs-button type="border" size="small" icon-pack="feather" icon="icon-trash" color="danger"></vs-button>
                </div> -->
              </div>              
            </div>
          </template>
      </vs-tr>
    </template>
  </vs-table>
</template>

<script>
export default {
  computed: {
    orderErrors () {
      if('orderErrors' in this.$store.state.AppActiveUser.cards){
        return this.$store.state.AppActiveUser.cards.orderErrors
      } else {            
        this.$store.commit('UPDATE_ORDER_ERRORS', this.$store.state.AppActiveUser.defaultState.cards.orderErrors)
        return this.$store.state.AppActiveUser.defaultState.cards.orderErrors
      }
    },
  },
  methods: {
    getOrderStatusColor (status) {
      if (status === 'cancelled' || status === 'pending' || status === 'refunded')   return 'dark'
      if (status === 'completed') return 'primary'
      if (status === 'processing')   return 'success'
      if (status === 'on_hold') return 'warning'
      if (status === 'failed')  return 'danger'
      return 'warning'
    },
    getFormatedDate(thedate) {  
      var dt = new Date( Number(thedate) );
      var dd = dt.getDate();
      var mm = dt.getMonth() + 1; //January is 0!
      var yyyy = dt.getFullYear();
      if (dd < 10) { dd = '0' + dd; } 
      if (mm < 10) { mm = '0' + mm; } 
      
      return mm + '-' + dd + '-' + yyyy + " " + dt.getHours() + ":" + dt.getMinutes() + ":" + dt.getSeconds();
    },
  },
}
</script>
